module.exports = __webpack_public_path__ + "img/40.a0dabe86.jpg";